import { Flex, Spinner } from '@cof/omni-react';

export const FullScreenLoader = () => {
  return (
    <div data-testid="FullScreenLoader">
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <Spinner size="giant" />
      </Flex>
    </div>
  );
};
